var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"aup-text-label",class:{
            'aup-text-label--white': _vm.color == 'white',
            'aup-text-label--orange': _vm.color == 'orange',
			'aup-text-label--black': _vm.color == 'black',
            'aup-text-label--light': _vm.color == 'light',
			'aup-text-label--inverted' : _vm.inverted == true,
			'aup-text-label--rounded' : _vm.rounded == true
        }},[_c('p',{staticClass:"t-heavy m-0 t-micro text-center",class:{
				'text-uppercase' : _vm.uppercase == true,
				'text-capitalize' : _vm.uppercase == false,
				't-micro--regular' : _vm.bold == false
			}},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }